import { useState, useEffect } from "react";
import { TextField, Typography } from "@mui/material";
import { getInputLabelProps, getInputProps } from "../../../common/appStyles";
import localize from "../../../common/localize";
import {
  getCurrencyFromSetup,
  getEventTotalValue,
} from "../../../common/EntitiesManagement";
import { getValueInCurrency } from "../../../common/utils";

export default function SetServiceValues({ eventModel, setEventModel }) {
  const [totalValue, setTotalValue] = useState(0);
  const handleValueChange = (input) => {
    const inputValue = parseInt(input.target.value);

    setEventModel({
      ...eventModel,
      [input.target.name]: inputValue > 0 ? inputValue : 0,
    });
  };

  useEffect(() => {
    setTotalValue(getEventTotalValue(eventModel, true));
  }, [eventModel]);

  return (
    <div style={{ width: "100%" }} className="flex flex-col gap-4 mt-2">
      <TextField
        type="number"
        InputLabelProps={getInputLabelProps()}
        inputProps={{
          ...getInputProps(),
          inputProps: {
            min: 0,
          },
        }}
        value={eventModel.sparePartsFinalValue}
        onChange={handleValueChange}
        size="small"
        id="sparePartsFinalValue"
        name="sparePartsFinalValue"
        label={localize.spare_parts_value}
        variant="outlined"
        fullWidth
        minV
      />

      <TextField
        type="number"
        InputLabelProps={getInputLabelProps()}
        inputProps={{
          ...getInputProps(),
          inputProps: {
            min: 0,
          },
        }}
        value={eventModel.executionFinalValue}
        onChange={handleValueChange}
        size="small"
        id="executionFinalValue"
        name="executionFinalValue"
        label={localize.service_value}
        variant="outlined"
        fullWidth
      />

      <Typography className="field_title_text">
        <b>{`${localize.total_value}: ${getValueInCurrency(
          getCurrencyFromSetup(),
          totalValue
        )}`}</b>
      </Typography>
    </div>
  );
}
